import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import _isEqual from 'lodash/isEqual';
import { Component } from 'react';
import { ConversationStatusColorBox } from 'components/conversation';
import { getConversationTitle, getHumanConversationChannel, } from '../../../app/utils/conversationTitle';
import { ActivityLog } from '../../activityLog/components/activityLog';
import ConversationSidebar from '../containers/conversationSidebar';
import MessageSection from '../containers/messageSection';
import ReplySection from '../containers/replySection';
import Timeline from '../containers/timeline';
import { canClaimConversation } from '../utils/canClaimConversation';
import { canTakeOverConversation } from '../utils/canTakeOverConversation';
import { ConversationContextProvider } from './ConversationProvider';
import { ConversationSummary } from './conversationSummary';
import { ConversationHeader } from './header';
import { SubConversationList } from './subConversationList';
import '../styles/conversation.less';
class Conversation extends Component {
    constructor(props) {
        super(props);
        this.getCsid = this.getCsid.bind(this);
    }
    componentDidMount() {
        const csid = this.getCsid(this.props.params);
        if (csid) {
            this.prepConversationByCSID(csid);
        }
    }
    shouldComponentUpdate(nProps) {
        return !_isEqual(this.props, nProps);
    }
    componentDidUpdate(prevProps) {
        const csid = this.getCsid(this.props.params);
        if (csid && csid !== this.getCsid(prevProps.params)) {
            this.prepConversationByCSID(csid);
        }
    }
    componentWillUnmount() {
        this.props.conversationUnmount();
    }
    prepConversationByCSID(csid) {
        if (csid) {
            this.props.conversationResetUnread({ csid });
            this.props.conversationGet({ csid }).catch((err) => {
                console.error('Caught', err);
                return err;
            });
            this.props.notificationTabBadgeReset();
        }
    }
    getCsid(params) {
        const { csid } = params;
        if (csid !== undefined && typeof csid === 'string') {
            return parseInt(csid, 10);
        }
        return undefined;
    }
    getConversationAgent(conversation) {
        return conversation &&
            conversation.assignment &&
            conversation.assignment.agent &&
            typeof conversation.assignment.agent.name === 'string'
            ? conversation.assignment.agent.name
            : null;
    }
    getConversationRequesterDetails(requester) {
        return requester
            ? requester.name || requester.email || requester.phone_number || null
            : null;
    }
    getConversationQueue(conversation) {
        return conversation &&
            conversation.queue &&
            typeof conversation.queue === 'string'
            ? conversation.queue
            : null;
    }
    canFollowUpConversation() {
        const { metaConversation } = this.props;
        const isAssigned = metaConversation.conversation.assignment === null ? false : true;
        if (isAssigned) {
            return true;
        }
        return false;
    }
    renderContent(params) {
        const { showTakeoverButton, showClaimButton } = params;
        const { requester } = this.props.metaConversation;
        return this.props.isActivityLogOpen ? (_jsx(ActivityLog, {})) : (_jsxs("div", Object.assign({ className: "content message-content scrollable", style: { padding: 0 } }, { children: [_jsx(MessageSection, {}), !(requester === null || requester === void 0 ? void 0 : requester.anonymized_at) && (_jsx(ReplySection, { showTakeoverButton: showTakeoverButton, showClaimButton: showTakeoverButton ? false : showClaimButton }))] })));
    }
    render() {
        const { metaConversation, navigate, latestMessengerConversation, isCustomCardMenuOpen, } = this.props;
        const { parentConversation, parentConversationRequester, linkedConversations, conversation, isAssignedToMe, } = metaConversation;
        const showTakeoverButton = canTakeOverConversation(conversation, isAssignedToMe);
        const showClaimButton = canClaimConversation(conversation, isAssignedToMe, latestMessengerConversation);
        return (_jsxs("div", Object.assign({ className: classnames('conversation-view', {
                'conversation-view--has-children': linkedConversations && linkedConversations.length > 0,
            }) }, { children: [!parentConversation && (_jsx("div", Object.assign({ className: classnames('conversation-view__timeline', {
                        'conversation-view__timeline--placeholder': !!parentConversation,
                    }) }, { children: _jsx(Timeline, {}) }))), _jsxs("div", Object.assign({ className: "conversation-view__main" }, { children: [!!parentConversation && (_jsxs("div", Object.assign({ className: "conversation-view__parent", onClick: () => navigate('/conversation/' + parentConversation.id), "data-status": parentConversation.status }, { children: [_jsx(ConversationStatusColorBox, { className: "conversation-status", conversation: parentConversation }), _jsx(ConversationSummary, { className: "conversation-view__parent__summary", conversationAttributes: metaConversation.conversation.attributes, conversationInfo: parentConversation, labels: {
                                        title: getConversationTitle({
                                            conversation: parentConversation,
                                            requester: parentConversationRequester,
                                        }),
                                        agent: this.getConversationAgent(parentConversation),
                                        requester: this.getConversationRequesterDetails(parentConversationRequester),
                                        queue: this.getConversationQueue(parentConversation),
                                        channel: getHumanConversationChannel(parentConversation),
                                    } })] }))), _jsx("div", Object.assign({ "data-status": this.props.metaConversation.conversation.status, className: "conversation-view__current content-panel conversation-messages" }, { children: _jsxs(ConversationContextProvider, Object.assign({ csid: this.getCsid(this.props.params) }, { children: [_jsx(ConversationStatusColorBox, { className: "conversation-status", conversation: conversation }), _jsx(ConversationHeader, {}), this.renderContent({ showTakeoverButton, showClaimButton })] })) })), !parentConversation &&
                            linkedConversations &&
                            linkedConversations.length > 0 && (_jsx("div", Object.assign({ className: "conversation-view__children" }, { children: _jsx(SubConversationList, { conversations: linkedConversations.map((metaC) => {
                                    return {
                                        info: metaC.conversation,
                                        requester: metaC.requester,
                                        labels: {
                                            title: getConversationTitle(metaC),
                                            agent: this.getConversationAgent(metaC.conversation),
                                            queue: this.getConversationQueue(metaC.conversation),
                                            channel: getHumanConversationChannel(metaC.conversation),
                                        },
                                    };
                                }), onConversationClick: (csid) => navigate('/conversation/' + csid) }) })))] })), _jsx("div", Object.assign({ className: classnames('conversation-view__sidebar', {
                        closed: !isCustomCardMenuOpen,
                    }) }, { children: _jsx(ConversationSidebar, {}) })), _jsx("div", { className: classnames('conversation-view__backdrop', {
                        closed: !isCustomCardMenuOpen,
                    }), onClick: this.props.closeSideBarMenu })] })));
    }
}
export default Conversation;
